<template>
  <el-dialog
    title="付款"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    @close="handleClose"
    class="payment-dialog"
    top="10vh"
  >
    <div class="payment-dialog-content">
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-width="140px"
        size="small"
        class="payment-form"
      >
        <!-- 第1行：房屋地址 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="房屋地址" prop="房屋地址">
              <el-input v-model="formData.房屋地址" disabled />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第2行：付款金额 + 预计付款日期 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="付款金额" prop="付款金额">
              <el-input-number
                v-model="formData.付款金额"
                :min="0"
                :precision="2"
                :step="100"
                disabled
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="预计付款日期" prop="预计付款日期">
              <el-date-picker
                v-model="formData.预计付款日期"
                type="date"
                placeholder="请选择预计付款日期"
                value-format="timestamp"
                disabled
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第3行：实际付款时间 + 实际付款金额 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="实际付款时间" prop="实际付款时间" required>
              <el-date-picker
                v-model="formData.实际付款时间"
                type="date"
                placeholder="请选择实际付款时间"
                value-format="timestamp"
                :default-value="new Date()"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际付款金额" prop="实际付款金额" required>
              <el-input-number
                v-model="formData.实际付款金额"
                :min="0"
                :precision="2"
                :step="100"
                controls-position="right"
                placeholder="请输入实际付款金额"
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第4行：备注 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="备注" prop="备注">
              <el-input v-model="formData.备注" placeholder="请输入备注（可选）" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第5行：付款凭证 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="file-group">
              <div class="file-group-header">
                <span class="file-group-title">付款凭证</span>
                <el-button type="primary" size="small" icon="el-icon-upload2" @click="openUploadDialog">
                  添加凭证
                </el-button>
              </div>
              <el-table :data="fileList" border stripe size="small" v-loading="fileLoading">
                <el-table-column type="index" label="序号" width="60" align="center" />
                <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
                <el-table-column label="预览" width="150" align="center">
                  <template slot-scope="{ row }">
                    <div v-if="isImage(row.suffix) && (row.show_path_full || row.show_path)" class="preview-thumbnail">
                      <el-image
                        :src="row.show_path_full || row.show_path"
                        fit="cover"
                        style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                        :preview-src-list="[row.show_path_full || row.show_path]"
                      />
                    </div>
                    <span v-else class="preview-placeholder">仅支持图片预览</span>
                  </template>
                </el-table-column>
                <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
                <el-table-column label="操作" width="160" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="handleViewFile(row)">查看</el-button>
                    <el-button type="text" size="mini" style="color: #f56c6c;" @click="handleDeleteFile(row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="fileList.length === 0" class="empty-tip">
                暂无付款凭证
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 底部按钮 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">提交</el-button>
    </span>

    <!-- ====== 上传文件弹窗 ====== -->
    <el-dialog
      title="添加付款凭证"
      :visible.sync="uploadDialog.visible"
      width="520px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="resetUploadForm"
    >
      <el-form :model="uploadForm" label-width="100px" size="small">
        <el-form-item label="选择文件" required>
          <el-upload
            ref="uploadRef"
            :auto-upload="false"
            :limit="1"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            action="#"
            accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
          >
            <el-button size="small" type="primary">点击选择文件</el-button>
            <span slot="tip" class="el-upload__tip">支持 jpg、jpeg、png、pdf、doc、docx</span>
          </el-upload>
          <div v-if="uploadForm.fileName" style="margin-top: 8px; font-size: 13px; color: #409EFF;">
            已选择：{{ uploadForm.fileName }}
          </div>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="uploadForm.bz" placeholder="请输入备注（可选）" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="uploadDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleUploadSubmit" :loading="uploading">确认</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { fileMethod } from '@/api/files/fileMethod'
import { sfPlanApi } from '@/api/付款/sfPlanApi'

export default {
  name: 'PaymentDialog',

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      dialogVisible: this.visible,
      submitting: false,
      uploading: false,
      fileLoading: false,

      // 当前记录ID
      currentRecordId: null,

      // 表单数据
      formData: {
        房屋地址: '',
        付款金额: null,
        预计付款日期: null,
        实际付款时间: null,
        实际付款金额: null,
        备注: ''
      },

      formRules: {
        实际付款时间: [
          { required: true, message: '请选择实际付款时间', trigger: 'change' }
        ],
        实际付款金额: [
          { required: true, message: '请输入实际付款金额', trigger: 'blur' }
        ]
      },

      // 凭证列表
      fileList: [],

      // 上传弹窗
      uploadDialog: {
        visible: false,
        title: '添加付款凭证'
      },
      uploadForm: {
        file: null,
        fileName: '',
        bz: ''
      }
    }
  },

  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val && this.rowData) {
        this.initData()
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
      if (!val) {
        this.resetForm()
      }
    }
  },

  methods: {
    // ====== 初始化数据 ======
    initData() {
      if (!this.rowData) return

      const data = this.rowData
      this.currentRecordId = data.id

      this.formData = {
        房屋地址: data.房屋地址 || '',
        付款金额: data.付款金额 || null,
        预计付款日期: data.付款日期 || null,
        实际付款时间: new Date().getTime(),
        实际付款金额: data.付款金额 || null,
        备注: ''
      }

      // 加载已有的付款凭证
      this.loadFileList()

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },

    // ====== 重置表单 ======
    resetForm() {
      this.formData = {
        房屋地址: '',
        付款金额: null,
        预计付款日期: null,
        实际付款时间: null,
        实际付款金额: null,
        备注: ''
      }
      this.fileList = []
      this.currentRecordId = null
      this.submitting = false
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }
      })
    },

    // ====== 关闭弹窗 ======
    handleClose() {
      this.dialogVisible = false
    },

    // ====== 判断是否为图片 ======
    isImage(suffix) {
      if (!suffix) return false
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      return imageTypes.includes(suffix.toLowerCase())
    },

    // ====== 获取文件后缀 ======
    getFileSuffix(fileName) {
      const parts = fileName.split('.')
      return parts.length > 1 ? parts[parts.length - 1] : ''
    },

    // ====== 加载已有的付款凭证 ======
    async loadFileList() {
      if (!this.currentRecordId) return

      this.fileLoading = true
      const fileBaseUrl = window.applicationConfig?.fileBaseUrl || window.location.origin + '/nngy/'

      try {
        const res = await fileMethod.listFiles('收房付款计划', String(this.currentRecordId), '付款凭证', null)
        console.log('加载付款凭证返回:', res)

        if (res.code === 200) {
          const list = res.data?.list || []
          this.fileList = list.map(item => {
            if (item.show_path) {
              const isFullUrl = item.show_path.startsWith('http://') || item.show_path.startsWith('https://')
              item.show_path_full = isFullUrl ? item.show_path : fileBaseUrl + item.show_path.replace(/^\//, '')
            } else {
              item.show_path_full = ''
            }
            return item
          })
        }
      } catch (error) {
        console.error('加载付款凭证失败:', error)
      } finally {
        this.fileLoading = false
      }
    },

    // ====== 打开上传弹窗 ======
    openUploadDialog() {
      if (!this.currentRecordId) {
        this.$message.warning('记录ID不存在，无法上传附件')
        return
      }

      this.uploadDialog.visible = true
      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.bz = ''

      this.$nextTick(() => {
        if (this.$refs.uploadRef) {
          this.$refs.uploadRef.clearFiles()
        }
      })
    },

    // ====== 文件选择变化 ======
    handleFileChange(file) {
      this.uploadForm.file = file.raw
      this.uploadForm.fileName = file.name
    },

    // ====== 文件移除 ======
    handleFileRemove() {
      this.uploadForm.file = null
      this.uploadForm.fileName = ''
    },

    // ====== 重置上传表单 ======
    resetUploadForm() {
      this.uploadForm.file = null
      this.uploadForm.fileName = ''
      this.uploadForm.bz = ''
      this.uploading = false
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.clearFiles()
      }
    },

    // ====== 上传付款凭证 ======
    async handleUploadSubmit() {
      if (!this.uploadForm.file) {
        this.$message.warning('请选择文件')
        return
      }

      this.uploading = true

      try {
        const res = await fileMethod.uploadFile(
          this.uploadForm.file,
          '收房付款计划',
          String(this.currentRecordId),
          '付款凭证',
          '',
          this.uploadForm.bz || ''
        )
        console.log('上传付款凭证返回:', res)

        if (res.code === 200) {
          this.$message.success('上传成功')
          this.uploadDialog.visible = false
          // 重新加载凭证列表
          await this.loadFileList()
        } else {
          this.$message.error(res.message || '上传失败')
        }
      } catch (error) {
        console.error('上传失败:', error)
        this.$message.error(error.message || '上传失败，请稍后重试')
      } finally {
        this.uploading = false
      }
    },

    // ====== 查看文件 ======
    handleViewFile(row) {
      const url = row.show_path_full || row.show_path
      if (url) {
        window.open(url, '_blank')
      } else {
        this.$message.warning('文件路径不存在')
      }
    },

    // ====== 删除付款凭证 ======
    async handleDeleteFile(row) {
      if (!row.id) {
        this.$message.warning('文件ID不存在')
        return
      }

      this.$confirm(
        `确认删除文件 "${row.show_name}" 吗？删除后不可撤回！`,
        '提示',
        {
          type: 'warning',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消'
        }
      ).then(async () => {
        try {
          const res = await fileMethod.deleteFile(row.id)
          console.log('删除凭证返回:', res)

          if (res.code === 200 && res.data?.deleted) {
            this.$message.success('删除成功')
            // 从列表中移除
            this.fileList = this.fileList.filter(item => item.id !== row.id)
          } else {
            this.$message.warning(res.data?.message || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error(error.message || '删除失败，请稍后重试')
        }
      }).catch(() => {})
    },

    // ====== 提交 ======
    async handleSubmit() {
      // 表单验证
      try {
        await this.$refs.formRef.validate()
      } catch (error) {
        this.$message.warning('请完善表单信息')
        return
      }

      // 构建二次确认提示
      const warnings = []
      const actualAmount = this.formData.实际付款金额
      const expectedAmount = this.formData.付款金额

      // 检查实际付款金额是否等于预计付款金额
      if (actualAmount !== expectedAmount) {
        warnings.push('1. 实际付款金额不等于需要的付款金额')
      }

      // 检查是否有付款凭证
      if (this.fileList.length === 0) {
        warnings.push('2. 未上传附件凭证')
      }

      let confirmMessage = '确认提交付款信息吗？'
      if (warnings.length > 0) {
        confirmMessage = `检测到以下问题：\n${warnings.join('；\n')}\n\n是否继续保存？`
      }

      try {
        await this.$confirm(confirmMessage, '提示', {
          type: 'warning',
          confirmButtonText: '确认提交',
          cancelButtonText: '取消'
        })
      } catch {
        return
      }

      this.submitting = true

      try {
        // 构建更新参数
        const updateParams = {
          id: this.currentRecordId,
          状态: '待审核',
          实际付款时间: Math.floor(this.formData.实际付款时间 / 1000),
          实际付款金额: Math.round(this.formData.实际付款金额 * 100) / 100,
          备注: this.formData.备注 || ''
        }

        console.log('付款更新参数===', updateParams)

        const res = await sfPlanApi.update(updateParams)
        console.log('付款更新返回===', res)

        if (res.code === 200) {
          this.$message.success('付款提交成功，状态已更新为"待审核"')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.message || '提交失败')
        }
      } catch (error) {
        console.error('提交失败:', error)
        this.$message.error(error.message || '提交失败，请稍后重试')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.payment-dialog /deep/ .el-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.payment-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.payment-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.payment-dialog-content {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;
}

.payment-dialog-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.payment-dialog-content::-webkit-scrollbar-track {
  background: #f0f2f5;
  border-radius: 3px;
}

.payment-dialog-content::-webkit-scrollbar-thumb {
  background: #c1c7cd;
  border-radius: 3px;
}

.payment-dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8b0b8;
}

.payment-dialog-content {
  scrollbar-width: thin;
  scrollbar-color: #c1c7cd #f0f2f5;
}

.payment-form /deep/ .el-form-item {
  margin-bottom: 18px;
}

.payment-form /deep/ .el-form-item__label {
  font-weight: 500;
  color: #606266;
  padding-right: 12px;
}

.payment-form /deep/ .el-input-number {
  width: 100%;
}

.payment-form /deep/ .el-input-number .el-input__inner {
  text-align: left;
}

.payment-form /deep/ .el-select {
  width: 100%;
}

.payment-form /deep/ .el-date-editor {
  width: 100%;
}

/* ====== 附件分组 ====== */
.file-group {
  margin-bottom: 4px;
}

.file-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 10px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
}

.file-group-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.preview-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-placeholder {
  font-size: 12px;
  color: #909399;
}

.empty-tip {
  text-align: center;
  padding: 12px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 4px;
}

@media (max-width: 768px) {
  .payment-dialog /deep/ .el-dialog {
    width: 95% !important;
  }
}
</style>